<template>
<BaseTemplate>
  <div class="base">
    <Title :jpn="t('登録情報')"></Title>
    <div class="input-area">
      <SubTitle class="subtitle">{{ t('名前') }}</SubTitle>
      <div class="address_area flex">
        <div class="last-name-container">
          <TextBox
            class="text-box"
            inputType="text"
            :value="lastName"
            :placeholder="t('姓')"
            @handleTextInput="inputLastName"
          />
          <ErrorMessage
            v-if="errorMessageLastName"
            class="error-message"
            :message="errorMessageLastName"
          />
        </div>
        <div v-if="countryId != '84'" class="first-name-container">
          <TextBox
            class="text-box"
            inputType="text"
            :value="middleName"
            :placeholder="t('ミドルネーム')"
            @handleTextInput="inputMiddleName"
          />
          <ErrorMessage
            v-if="errorMessageMiddleName"
            class="error-message"
            :message="errorMessageMiddleName"
          />
        </div>
        <div class="first-name-container">
          <TextBox
            class="text-box"
            inputType="text"
            :value="firstName"
            :placeholder="t('名')"
            @handleTextInput="inputFirstName"
          />
          <ErrorMessage
            v-if="errorMessageFirstName"
            class="error-message"
            :message="errorMessageFirstName"
          />
        </div>
      </div>
      <div class="address_area">
        <LabelItem
          class="label-item"
          :label="t('国')"
          :text="countryName"
        />
        <LabelInput
          class="label-input"
          :labelText="t('郵便番号')"
        >
          <TextBox
            class="text-box"
            inputType="text"
            :value="zipCode"
            :placeholder="t('郵便番号')"
            @handleTextInput="inputZipCode"
            @handleTextBlur="changeZipCode"
          />
          <ErrorMessage
            v-if="errorMessageZipCode"
            class="error-message"
            :message="errorMessageZipCode"
          />
        </LabelInput>
        <LabelInput v-if="countryId == '84'" class="label-input" :labelText="t('都道府県')">
          <SelectBox
            :memberChange="true"
            :options="prefectureSelectList"
            :selectedOption="prefectureId"
            :value="prefectureId"
            @handleSelectChange="selectPrefectureId"
          />
          <ErrorMessage
            v-if="errorMessagePrefectureId"
            class="error-message"
            :message="errorMessagePrefectureId"
          />
        </LabelInput>
        <LabelInput v-if="countryId != '84'" class="label-input" :labelText="t('州')">
          <TextBox
            class="text-box"
            inputType="text"
            :value="province"
            :placeholder="t('州')"
            @handleTextInput="inputProvince"
          />
          <ErrorMessage
            v-if="errorMessageProvince"
            class="error-message"
            :message="errorMessageProvince"
          />
        </LabelInput>
        <LabelInput class="label-input" :labelText="t('市区町村')">
          <TextBox
            class="text-box"
            inputType="text"
            :value="shiku"
            :placeholder="t('市区町村')"
            @handleTextInput="inputShiku"
          />
          <ErrorMessage
            v-if="errorMessageShiku"
            class="error-message"
            :message="errorMessageShiku"
          />
        </LabelInput>
        <LabelInput class="label-input" :labelText="t('番地')">
          <TextBox
            class="text-box"
            inputType="text"
            :value="address"
            :placeholder="t('番地')"
            @handleTextInput="inputAddress"
          />
          <ErrorMessage
            v-if="errorMessageAddress"
            class="error-message"
            :message="errorMessageAddress"
          />
        </LabelInput>
        <LabelInput
          class="label-input"
          :labelText="t('建物名')"
        >
          <TextBox
            class="text-box"
            inputType="text"
            :value="building"
            :placeholder="t('建物名')"
            @handleTextInput="inputBuilding"
          />
          <ErrorMessage
            v-if="errorMessageBuilding"
            class="error-message"
            :message="errorMessageBuilding"
          />
        </LabelInput>
        <LabelInput
          class="label-input"
          :labelText="t('言語')"
        >
        <SelectBox
          :memberChange="true"
          :options="formatLanguageList"
          :selectedOption="languageId"
          :value="languageId"
          @handleSelectChange="changeLanguageId"
        />
        <ErrorMessage
          v-if="errorMessageLanguageId"
          class="error-message"
          :message="errorMessageLanguageId"
        />
        </LabelInput>
        <div class="button_area">
          <BuyButton
            :isArrow="false"
            class="label-input nomt sms_button"
            :text="t('変更する')"
            @handleSquareBtnClick="updateAddressAndLanguage"
          />
        </div>
      </div>
      <SubTitle id="tel" class="subtitle">{{ t('電話番号') }}</SubTitle>
      <div class="address_area">
        <TextBox
          class="text-box tel"
          inputType="text"
          :value="tel"
          :readonly="end_sms == 1"
          placeholder="01234567890"
          @handleTextInput="inputTel"
        />
        <ErrorMessage
          v-if="errorMessageTel"
          class="error-message"
          :message="errorMessageTel"
        />
        <div class="button_area">
          <BuyButton
            :isArrow="false"
            class="label-input nomt sms_button"
            :text="t('SMS認証')"
            v-if="end_sms == 0"
            @handleSquareBtnClick="smsPopup"
          />
        </div>
      </div>

      <SubTitle class="subtitle">{{ t('メールアドレス') }}</SubTitle>
      <div class="address_area">
        <LabelItem
          class="label-item"
          :text="mail"
        />
      </div>

      <SubTitle class="subtitle">{{ t('友達紹介コード') }}</SubTitle>
      <div class="address_area">
        <LabelItem
          class="label-item referralCode"
          :text="referral_code"
        />
      </div>
    </div>

    <div v-if="!countryName" class="contact_message">
      {{ t('初めて配送を選択する際に、この情報を入力できます。') }}
    </div>
    <div class="button_area">
      <SquareButton
        class="label-input nomt square-button"
        :text="t('戻る')"
        @handleSquareBtnClick="goToBack"
      />
    </div>
  </div>
  <AlertSuccess
    ref="alertSuccess"
    :isShow="isShowAlertSuccess"
    :text="t('変更が完了しました')"
    v-click-outside="closeAlertSuccess"
  />
  <AlertSuccess
    ref="alertSMSSuccess"
    :isShow="isShowSMSAlertSuccess"
    :text="t('変更が完了しました')"
    v-click-outside="closeSMSAlertSuccess"
  />
  <SMSPopup
    v-if="showSMSPopup"
    :tel="tel"
    @success="smsSuccess"
    @closePopup="showSMSPopup = false">
  </SMSPopup>
</BaseTemplate>
</template>

<script>
/* eslint-disable eqeqeq, no-alert */
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import AlertSuccess from '@/components/atoms/AlertSuccess.vue';
import SMSPopup from '@/components/molecules/SMSPopup.vue';
import LabelItem from '@/components/molecules/LabelItem.vue';
import Title from '@/components/molecules/Title02.vue';
import SubTitle from '@/components/molecules/SubTitle.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import SelectBox from '@/components/atoms/SelectBox.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import LabelInput from '@/components/molecules/LabelInput.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';
import t from '@/plugins/i18n';

export default {
  mixins: [t],

  components: {
    BaseTemplate,
    AlertSuccess,
    LabelItem,
    TextBox,
    SMSPopup,
    ErrorMessage,
    LabelInput,
    Title,
    SubTitle,
    SquareButton,
    BuyButton,
    SelectBox,
  },

  data: () => ({
    languageId: null,
    errorMessageCountryId: '',
    errorMessageLanguageId: '',
    lastName: null,
    middleName: null,
    firstName: null,
    tel: null,
    mail: null,
    province: null,
    zipCode: null,
    prefectureId: null,
    country: null,
    prefName: null,
    shiku: null,
    address: null,
    building: null,
    password: null,
    point: null,
    end_sms: 0,
    referral_code: '',
    countryId: null,
    confirmPass: null,
    showSMSPopup: false,
    isShowAlertSuccess: false,
    isShowSMSAlertSuccess: false,
    errorMessageLastName: null,
    errorMessageMiddleName: null,
    errorMessageFirstName: null,
    errorMessageTel: null,
    errorMessageMail: null,
    errorMessageProvince: null,
    errorMessageZipCode: null,
    errorMessagePrefectureId: null,
    errorMessageCountry: null,
    errorMessageShiku: null,
    errorMessageAddress: null,
    errorMessageBuilding: null,
  }),

  computed: {
    ...mapGetters({
      prefectureList: 'prefecture/prefectureList',
      languageList: 'language/languageList',
      currentUser: 'user/currentUser',
      currentUserDetail: 'user/currentUserDetail',
      currentAddress: 'zipCode/currentAddress',
      changeUserInformationResult: 'user/changeUserInformationResult',
      changeUserAddressResult: 'user/changeUserAddressResult',
      logOutUserResult: 'user/logOutUserResult',
      countryList: 'country/countryList',
      changeLanguageResult: 'user/changeLanguageResult',
    }),
    formatLanguageList() {
      if (this.languageList) {
        return this.languageList.slice(1);
      }
      return [];
    },
    countryName() {
      if (this.countryList) {
        if (this.countryId && this.countryId !== '0') {
          const found = this.countryList.find(
            (country) => country.id === this.countryId,
          );
          return found ? found.name : null;
        }
      }
      return null;
    },
    countrySelectList() {
      if (this.countryList) {
        return this.countryList.map((country) => ({
          id: country.id,
          name: country.name,
        }));
      }
      return [];
    },
    prefectureSelectList() {
      if (this.prefectureList) {
        const list = [{ id: '', name: this.t('選択してください') }];
        return list.concat(this.prefectureList.map((pref) => ({
          id: pref.id,
          name: pref.name,
        })));
      }
      return [];
    },
  },

  watch: {
    currentAddress(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          const { result } = newVal;
          this.selectPrefectureId(result[0].prefcode);
          this.inputShiku(`${result[0].address2}${result[0].address3}`);
        }
      }
    },
    changeLanguageResult(newVal) {
      if (newVal.state === 200) {
        this.isShowAlertSuccess = true;
        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else {
        const { language_id: languageId } = newVal.errors;
        this.errorMessageLanguageId = languageId ? languageId[0] : null;
      }
    },
    currentUserDetail(newResult) {
      this.$nextTick(() => {
        this.lastName = newResult.lastName;
        this.middleName = newResult.middleName;
        this.firstName = newResult.firstName;
        this.tel = newResult.tel;
        this.mail = newResult.mail;
        this.zipCode = newResult.zipcode;
        this.province = newResult.province;
        this.country = newResult.country;
        this.prefName = newResult.pref_name;
        this.shiku = newResult.shiku;
        this.address = newResult.address;
        this.building = newResult.building;
        this.point = newResult.availablePoint;
        this.end_sms = newResult.end_sms;
        this.referral_code = newResult.referral_code;
        this.countryId = newResult.country_id;
        // MEMO: 都道府県リストが更新されないため、レンダリング完了を待ち、さらに少し時間差をつける。（100に根拠はないが、リロードして動作を確認）
        setTimeout(() => {
          // 日本で都道府県が海外用(99)の場合はリセット
          if (newResult.country_id == '84' && newResult.pref_id == 99) {
            this.prefectureId = '';
          } else {
            this.prefectureId = newResult.pref_id;
          }
          this.languageId = newResult.language_id;
        }, 100);
        // mounted時にスクロールすると、スクロールが効かないため、ここでスクロールする
        this.$nextTick(() => {
          const url = window.location.href;
          if (url.includes('#tel')) {
            const el = document.getElementById('tel');
            if (el) {
              el.scrollIntoView({ behavior: 'smooth' });
            }
          }
        });
      });
    },
    changeUserInformationResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearChangeUserInformationResult');
          this.isShowAlertSuccess = true;
        } else {
          const {
            lastName, firstName, middleName, tel, mail, zipcode,
            province, pref_id: prefId, shiku, address, building,
          } = newVal.errors;
          this.errorMessageLastName = lastName ? lastName[0] : null;
          this.errorMessageMiddleName = middleName ? middleName[0] : null;
          this.errorMessageFirstName = firstName ? firstName[0] : null;
          this.errorMessageProvince = province ? province[0] : null;
          this.errorMessageTel = tel ? tel[0] : null;
          this.errorMessageMail = mail ? mail[0] : null;
          this.errorMessageZipCode = zipcode ? zipcode[0] : null;
          this.errorMessagePrefectureId = prefId ? prefId[0] : null;
          this.errorMessageShiku = shiku ? shiku[0] : null;
          this.errorMessageAddress = address ? address[0] : null;
          this.errorMessageBuilding = building ? building[0] : null;
        }
      }
    },
    changeUserAddressResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearChangeUserInformationResult');
          this.isShowAlertSuccess = true;
          // 言語が変更された場合はページをリロード
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else {
          const {
            lastName, firstName, middleName, tel, zipcode,
            province, pref_id: prefId, shiku, address, building, country_id: countryId,
            language_id: languageId,
          } = newVal.errors;
          this.errorMessageLastName = lastName ? lastName[0] : null;
          this.errorMessageMiddleName = middleName ? middleName[0] : null;
          this.errorMessageFirstName = firstName ? firstName[0] : null;
          this.errorMessageProvince = province ? province[0] : null;
          this.errorMessageTel = tel ? tel[0] : null;
          this.errorMessageZipCode = zipcode ? zipcode[0] : null;
          this.errorMessagePrefectureId = prefId ? prefId[0] : null;
          this.errorMessageShiku = shiku ? shiku[0] : null;
          this.errorMessageAddress = address ? address[0] : null;
          this.errorMessageBuilding = building ? building[0] : null;
          this.errorMessageCountryId = countryId ? countryId[0] : null;
          this.errorMessageLanguageId = languageId ? languageId[0] : null;
        }
      }
    },
  },

  created() {
    this.$store.dispatch('prefecture/setPrefectureList');
    this.$store.dispatch('user/setCurrentUserDetail');
    this.$store.dispatch('country/setCountryList');
    this.$store.dispatch('language/setLanguageList');
  },

  methods: {
    inputLastName(lastName) {
      this.lastName = lastName;
    },
    inputFirstName(firstName) {
      this.firstName = firstName;
    },
    inputMiddleName(name) {
      this.middleName = name;
    },
    inputTel(tel) {
      this.tel = tel;
    },
    inputMail(mail) {
      this.mail = mail;
    },
    inputZipCode(zipCode) {
      this.zipCode = zipCode;
    },
    inputCountry(country) {
      this.country = country;
    },
    selectPrefectureId(prefectureId) {
      this.prefectureId = prefectureId;
    },
    inputShiku(shiku) {
      this.shiku = shiku;
    },
    inputAddress(address) {
      this.address = address;
    },
    inputBuilding(building) {
      this.building = building;
    },
    inputProvince(province) {
      this.province = province;
    },
    changeCountryId(countryId) {
      this.countryId = countryId;
      // 国を変更した場合、日本以外なら都道府県を海外用(99)に設定
      if (countryId != '84') {
        this.prefectureId = 99;
      } else {
        // 日本に変更した場合は都道府県をリセット
        this.prefectureId = '';
      }
    },
    changeZipCode() {
      if (this.countryId == '84') {
        const zipCodeLength = 7;
        if (String(this.zipCode).length === zipCodeLength) {
          const postParams = {
            zipcode: this.zipCode,
          };
          this.$store.dispatch('zipCode/setCurrentAddress', { postParams });
        }
      }
    },
    updateAddressAndLanguage() {
      // 日本の場合は都道府県が必須（99は海外用なので無効）
      if (this.countryId == '84' && (this.prefectureId === null || this.prefectureId === '' || this.prefectureId === undefined || this.prefectureId == 99)) {
        this.errorMessagePrefectureId = this.t('都道府県を選択してください');
        return;
      }
      this.errorMessagePrefectureId = null;
      // 日本以外の場合は都道府県を海外用(99)に設定
      if (this.countryId != '84') {
        this.prefectureId = 99;
      }
      const postParams = {
        lastName: this.lastName,
        middleName: this.countryId != '84' ? this.middleName : '',
        firstName: this.firstName,
        tel: this.tel,
        zipcode: this.zipCode,
        pref_id: this.prefectureId,
        country_id: this.countryId,
        province: this.province,
        shiku: this.shiku,
        address: this.address,
        building: this.building,
        language_id: this.languageId,
      };
      this.$store.dispatch('user/changeUserAddress', { postParams });
    },
    smsPopup() {
      if (window.confirm(this.t('SMSコードを送信しますか？'))) {
        this.showSMSPopup = true;
      }
    },
    goToBack() {
      this.$router.push('/');
    },
    goToChangePassword() {
      this.$router.push('/change-password');
    },
    closeAlertSuccess() {
      this.isShowAlertSuccess = false;
    },
    closeSMSAlertSuccess() {
      this.isShowSMSAlertSuccess = false;
    },
    smsSuccess() {
      this.showSMSPopup = false;
      this.$store.dispatch('user/setCurrentUserDetail');
      this.isShowSMSAlertSuccess = true;
    },
    goContactUs() {
      window.open('https://minny-online-store.iranoan.com/contacts?service=1', '_blank');
    },
    changeLanguageId(languageId) {
      this.languageId = languageId;
    },
  },
};
</script>

<style lang="scss" scoped>
.base {
  padding-top: 30px;
  padding-bottom: 50px;
  max-width: 600px;
  margin: auto;
  .input-area {
    margin: 0;
    padding: 0 10px;
    .address_area {
      padding: 0;
      margin: 10px 0 10px 0;
      .row {
        margin: 5px 0;
      }
      .label-input {
        margin-top: 10px;
      }
    }
    .flex {
      display: flex;
      width: 100%;
      .last-name-container{
        flex: 1 1 150px;
        min-width: 0;
      }
      .first-name-container{
        flex: 1 1 150px;
        min-width: 0;
        margin-left: 15px;
      }
    }
    .announce-area {
      display: flex;
      align-items: center;
      .announce {
        color: $black;
        margin-left: 10px;
        font-size: 14px;
        width: 300px;
      }
    }
  }
  .subtitle{
    font-size: 15px;
    margin-top: 10px;
  }
  .button_area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .square-button {
      max-width: 200px;
      width: 100%;
      &:nth-child(2) {
        margin-top: 10px;
      }
    }
    .sms_button{
      min-width: 200px;
      font-size:medium;
      padding: 10px;
      &:hover {
        opacity: 0.7;

      }
    }
    .contact {
      font-size:medium;
      padding: 10px;
      &:hover {
        opacity: 0.7;
      }
    }
  }
  .referralCode {
    font-size: 24px;
  }
  .referral_message {
    color: $black;
  }
  .contact_message {
    margin: 10px auto;
    color: $mainColor;
    font-size: 20px;
    text-align: center;
  }
  .chat_message {
    margin: 10px auto;
    color: $mainColor;
    text-align: center;
    font-weight: 700;
  }
}
.text-red {
  margin: 10px auto;
  color: red;
  text-align: center;
}
@media screen and (max-width: $tabletWidth) {
  .base {
    .input-area {
      margin: 10px 0;
    }
    .contact_message {
      font-size: 16px;
    }
  }
}
</style>
